import React, { useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { Vector3 } from "three";
import { globalData } from "../../helpers/globData.ts";

const positionOffset = new Vector3(1.0814523696899414, 17.764172673225403, 0);
function Lights() {
  const camera = useThree().camera;
  const lightRefs = {
    lightGroup: useRef(null),
    left: useRef(null),
    right: useRef(null),
    mid: useRef(null),
    spot: useRef(null),
    ambient: useRef(null),
    up: useRef(null),
    down: useRef(null),
  };

  function setTargetedLayer(layerIndex) {
    Object.values(lightRefs).forEach(ref => {
      ref.current.mask = 0;
      layerIndex.forEach(layer => ref.current.layers.enable(layer));
    });
  }
  // const renderer = useThree();
  // renderer.gl.toneMapping = THREE.NoToneMapping;
  useFrame(() => {
    if (lightRefs.lightGroup?.current !== null) {
      lightRefs.lightGroup?.current?.rotation.copy(camera.rotation);
      setTargetedLayer(globalData.lightLayer);
      // pointLightRef.current.getWorldPosition(worldPosition);
      // pointLightRef.current.decay = lerp(
      //   2.15,
      //   2.4,
      //   Math.min(-Math.abs(worldPosition.y), worldPosition.z) / -60
      // );
      lightRefs.up.current.decay = lerp(3.3, 1.95, 0);
      lightRefs.down.current.decay = lerp(3.3, 1.95, 0);
    }
  });

  function lerp(a, b, alpha) {
    return a + alpha * (b - a);
  }
  return (
    <group name="Light Group">
      <group ref={lightRefs.lightGroup}>
        <group position={positionOffset}>
          <ambientLight
            ref={lightRefs.ambient}
            color={0xfffcf5}
            intensity={0.6}
          />
          <pointLight
            ref={lightRefs.right}
            position={[25, -20, 60]}
            decay={2.1}
            intensity={2500}
            distance={150}
            color={0xfffcf5}
          />
          <pointLight
            ref={lightRefs.left}
            position={[-25, -20, 60]}
            decay={2.1}
            intensity={2700}
            distance={150}
            color={0xfffcf5}
          />
          <pointLight
            ref={lightRefs.mid}
            position={[-15, -20, -60]}
            decay={2.1}
            intensity={2700}
            distance={150}
            color={0xfffcf5}
          />
        </group>
      </group>
      <spotLight
        ref={lightRefs.spot}
        position={[0, 0, -60]}
        decay={1.9}
        intensity={2500}
        distance={150}
        angle={0.5}
        penumbra={0.5}
      />
      <pointLight
        ref={lightRefs.down}
        position={[0, -70, 0]}
        decay={3.3}
        intensity={2500}
        distance={150}
      />
      <pointLight
        ref={lightRefs.up}
        position={[0, 50, 0]}
        decay={3.3}
        intensity={2500}
        distance={150}
      />
    </group>
  );
}

export default Lights;
